// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"MainLoader_loaderWrapper__8z8AJ","loaderBody":"MainLoader_loaderBody__TrlMf","loaderSvg":"MainLoader_loaderSvg__GnFq8","loaderText":"MainLoader_loaderText__Vuv-M"};